import Vue from "vue";
import App from "./App.vue";
import VueCountdown from "@chenfengyuan/vue-countdown";

import "bootstrap";
import "./sass/app.scss";

Vue.config.productionTip = false;
Vue.component(VueCountdown.name, VueCountdown);

new Vue({
    render: (h) => h(App),
}).$mount("#app");
